var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5022 5.65681C29.8791 6.01821 30.9633 7.08308 31.3313 8.43537C32 10.8862 32 16 32 16C32 16 32 21.1136 31.3313 23.5648C30.9633 24.9169 29.8791 25.9818 28.5022 26.3434C26.0067 27 16 27 16 27C16 27 5.99327 27 3.49782 26.3434C2.12109 25.9818 1.03673 24.9169 0.668727 23.5648C0 21.1136 0 16 0 16C0 16 0 10.8862 0.668727 8.43537C1.03673 7.08308 2.12109 6.01821 3.49782 5.65681C5.99327 5 16 5 16 5C16 5 26.0067 5 28.5022 5.65681ZM21.0909 16.0002L12.7273 20.6429V11.3571L21.0909 16.0002Z",
    fill: "var(--template-primary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.b9245f5b02a34107c17f4c7f138e5abe.svg";
export { ForwardRef as ReactComponent };